import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { selectEntityState } from '../reducers/entityStatesSlice';
import { actionColorTemperature } from '../actions/ActionColorTemperature';
import { Range } from './Range';
export const EntityColorTemperature = props => {
    var _a, _b, _c, _d;
    const entityState = useAppSelector(selectEntityState(props.entity.id));
    const dispatch = useAppDispatch();
    if (props.entity.title !== 'color_temperature' || props.action.title !== 'color_temperature') {
        return null;
    }
    const actionType = props.action.type;
    if (actionType.name != 'real')
        return null;
    // 1 and 65279 are the min and max values from the zigbee spec
    const min = (_b = (_a = actionType.options) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : 1;
    const max = (_d = (_c = actionType.options) === null || _c === void 0 ? void 0 : _c.max) !== null && _d !== void 0 ? _d : 65279;
    let temperature = (entityState === null || entityState === void 0 ? void 0 : entityState.value.type) == 'real' ? entityState === null || entityState === void 0 ? void 0 : entityState.value.value : min;
    const kelvin = Math.round(1000000 / temperature);
    // invert value so the darkest is to the left
    temperature = max - temperature + min;
    const onChange = (event) => {
        const val = event.target.value;
        const num = parseFloat(val);
        if (!isNaN(num)) {
            const invertedNum = max - num + min;
            dispatch(actionColorTemperature(props.action.id, invertedNum));
        }
    };
    return _jsxs(React.Fragment, { children: ["F\u00E4rgtemperatur (", kelvin, "K): ", _jsx(Range, { min: min, max: max, value: temperature, onChange: onChange })] });
};
